// Texte enrichi : une phrase qui contient des liens ou du gras s'écrit avec des balises
//   "un <lien>faire-part animé</lien> que vos invités ouvrent…"   +   components={{ lien: <Link to="…" /> }}
// La phrase reste UNE seule chaîne à traduire (l'ordre des mots change d'une langue à l'autre).
// Aucun HTML n'est injecté : seules les balises fournies par le composant (ou b, strong, i, em, br)
// deviennent des éléments ; toute autre balise est ignorée (son texte est gardé).
import React from 'react';

const TAG = /<(\/?)([A-Za-z][\w-]*)\s*(\/?)>/g;
const DEFAULTS = { b: <strong />, strong: <strong />, i: <em />, em: <em />, br: <br /> };
const VOID = new Set(['br']);

const parse = (str) => {
  const root = { children: [] };
  const stack = [root];
  let last = 0;
  let m;
  TAG.lastIndex = 0;
  while ((m = TAG.exec(str)) !== null) {
    if (m.index > last) stack[stack.length - 1].children.push(str.slice(last, m.index));
    last = m.index + m[0].length;
    const [, closing, name, selfClosing] = m;
    if (selfClosing || (!closing && VOID.has(name))) {
      stack[stack.length - 1].children.push({ name, children: [], selfClosing: true });
    } else if (!closing) {
      const node = { name, children: [] };
      stack[stack.length - 1].children.push(node);
      stack.push(node);
    } else {
      const at = stack.map((n) => n.name).lastIndexOf(name);
      if (at > 0) stack.length = at; // ferme la balise et celles restées ouvertes à l'intérieur
      else stack[stack.length - 1].children.push(m[0]); // fermeture sans ouverture : texte
    }
  }
  if (last < str.length) stack[stack.length - 1].children.push(str.slice(last));
  return root.children;
};

const build = (nodes, components, interpolate) => nodes.map((n, i) => {
  if (typeof n === 'string') return interpolate(n);
  const element = (components && components[n.name]) || DEFAULTS[n.name];
  if (!element) return <React.Fragment key={i}>{build(n.children, components, interpolate)}</React.Fragment>;
  if (n.selfClosing || VOID.has(n.name)) return React.cloneElement(element, { key: i });
  return React.cloneElement(element, { key: i }, ...build(n.children, components, interpolate));
});

/** Transforme une chaîne à balises en éléments React ; `interpolate` remplace les {{variables}} du texte. */
export const renderRich = (template, components, interpolate = (s) => s) => {
  const nodes = build(parse(String(template)), components, interpolate);
  return nodes.length === 1 && typeof nodes[0] === 'string' ? nodes[0] : <>{nodes}</>;
};
